import { render, staticRenderFns } from "./UserBadge.vue?vue&type=template&id=33056bf8&scoped=true"
import script from "./UserBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserBadge.vue?vue&type=style&index=0&id=33056bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33056bf8",
  null
  
)

export default component.exports